import React from 'react';
import './DeleteButton.css';

const DeleteButton = ({ onClick, children, disabled }) => (
  <button className="delete-button" onClick={onClick} disabled={disabled}>
    {children}
  </button>
);

export default DeleteButton;
